import {createSelector} from 'reselect';

export const selectFolder = (state) => state.folders;

export const makeSelectCreate = () =>
  createSelector(selectFolder, (folderState) => ({
    submitting: folderState.submitting,
    createSuccess: folderState.createSuccess,
    createFailed: folderState.createFailed,
    createError: folderState.createError,
  }));
